function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M32 2.54A29.46 29.46 0 112.54 32 29.5 29.5 0 0132 2.54M32 0a32 32 0 1032 32A32 32 0 0032 0z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2.54,
  d: "M32 21.22v16.79"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M37.7 35.32H26.3l5.7 7.46 5.7-7.46z",
  fill: "currentColor"
});

function SvgArrowCircleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij4KICAgIDx0aXRsZT5hcnJvdy1jaXJjbGUtZG93bjwvdGl0bGU+CiAgICA8cGF0aCBkPSJNMzIsMi41NEEyOS40NiwyOS40NiwwLDEsMSwyLjU0LDMyLDI5LjUsMjkuNSwwLDAsMSwzMiwyLjU0TTMyLDBBMzIsMzIsMCwxLDAsNjQsMzIsMzIsMzIsMCwwLDAsMzIsMFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgogICAgPGxpbmUgeDE9IjMyIiB5MT0iMjEuMjIiIHgyPSIzMiIgeTI9IjM4LjAxIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjIuNTQiLz4KICAgIDxwYXRoIGQ9Ik0zNy43LDM1LjMySDI2LjNMMzIsNDIuNzhsNS43LTcuNDZaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+";
export { SvgArrowCircleDown as ReactComponent };